import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';
import {
  ContentWrapper,
  LeftColumnWrapperVersionTwo,
  RightColumnWrapperVersionTwo,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import NoDataAndLoading from 'components/NoDataAndLoading';
import {
  bankAccountPageRequest,
  setBankAccountDetail,
  hideRightColumn,
} from 'actions/setting/bankAccount';
import { askConfirmAction } from 'actions/confirm-action';
import { isDirty, reset } from 'redux-form';
import ActionBar from './ActionBar';
import List from './List';
import Form from './Form';
import AssignOutletsModal from './AssignOutletsModal';
import ConfirmAssignOutletsModal from './ConfirmAssignOutletsModal';
import DeleteModal from './DeleteModal';
import VerifyPhoneModal from './VerifyPhoneModal';
import VerifyOtpModal from './VerifyOtpModal';
import ActivityLogModal from './ActivityLogModal';
import MoveAwayModal from './MoveAwayModal';
import styles from './style.css';

class BankAccountV2 extends React.Component {
  componentDidMount() {
    this.props.dispatch(bankAccountPageRequest());

    browserHistory.listenBefore(location => {
      if (this.props.isDirtyBankAccountForm && !this.props.nextAction) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  componentWillUnmount() {
    this.props.dispatch(reset('bankAccountForm'));
    this.props.dispatch(setBankAccountDetail(null));
    this.props.dispatch(hideRightColumn());
  }

  render() {
    const {
      bankAccounts,
      openRightColumn,
      otp,
      showLoadingSpinnerPage,
    } = this.props;

    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <div className={`visible-below-1440px ${styles.wrapper}`}>
            <LeftColumnWrapperVersionTwo openRightColumn={openRightColumn}>
              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerPage}
                noDataToDisplay={bankAccounts.length === 0}
                title="No Data To Display"
                description="Add your bank account and activate mobile payment to join endless promo from our partner."
                linkLabel="Mobile payment acceptance"
                linkUrl="https://www.youtube.com/watch?v=AG7trV3R17Y"
                heightClass={`${styles['table-no-data-list']}`}
              />
              {bankAccounts.length !== 0 && <List />}
            </LeftColumnWrapperVersionTwo>
            <RightColumnWrapperVersionTwo openRightColumn={openRightColumn}>
              <Form />
              <AssignOutletsModal />
              <ConfirmAssignOutletsModal />
              <DeleteModal />
              <VerifyPhoneModal />
              {otp.sent && <VerifyOtpModal />}
            </RightColumnWrapperVersionTwo>
            <ActivityLogModal />
            <MoveAwayModal />
          </div>
          <div className={`visible-above-1440px ${styles.wrapper}`}>
            <LeftColumnWrapper openRightColumn={openRightColumn}>
              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerPage}
                noDataToDisplay={bankAccounts.length === 0}
                title="No Data To Display"
                description="Add your bank account and activate mobile payment to join endless promo from our partner."
                linkLabel="Mobile payment acceptance"
                linkUrl="https://www.youtube.com/watch?v=AG7trV3R17Y"
                heightClass={`${styles['table-no-data-list']}`}
              />
              {bankAccounts.length !== 0 && <List />}
            </LeftColumnWrapper>
            <RightColumnWrapper openRightColumn={openRightColumn}>
              <Form />
              <AssignOutletsModal />
              <ConfirmAssignOutletsModal />
              <DeleteModal />
              <VerifyPhoneModal />
              {otp.sent && <VerifyOtpModal />}
            </RightColumnWrapper>
            <ActivityLogModal />
            <MoveAwayModal />
          </div>
        </ContentWrapper>
      </PageWrapper>
    );
  }
}

function mapStateToProps(state) {
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const {
    bankAccountLists,
    openRightColumn,
    otp,
    showModalVerifyOtp,
  } = state.setting.bankAccount;
  const { nextAction } = state.confirmAction;

  return {
    bankAccounts: bankAccountLists,
    nextAction,
    openRightColumn,
    otp,
    showLoadingSpinnerPage,
    showModalVerifyOtp,
    isDirtyBankAccountForm: isDirty('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BankAccountV2);
